export const useSpeechToText = (onResult: (arg0: string) => void, onError: (arg0: string) => void) => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
   
    if (!SpeechRecognition) {
      console.error('Speech recognition is not supported in this browser.');
      return {
        startListening: () => alert('Speech recognition is not supported'),
        stopListening: () => {},
        isSupported: false,
      };
    }
   
    const recognition = new SpeechRecognition();
   
    
    recognition.continuous = false; 
    recognition.lang = 'en-US'; 
    recognition.interimResults = false; 
   
    const startListening = () => {
      recognition.start();
   
      recognition.onstart = () => {
        console.log('Voice recognition started.');
      };
   
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        console.log('Transcript:', transcript);
        if (onResult) onResult(transcript);
      };
   
      recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
        if (onError) onError(event.error);
      };
   
      recognition.onend = () => {
        console.log('Voice recognition ended.');
      };
    };
   
    const stopListening = () => {
      recognition.stop();
      console.log('Voice recognition stopped.');
    };
   
    return { startListening, stopListening, isSupported: true };
  };